import { useState } from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { SearchFormSchema, SearchFormValues } from '../../schema';
import { AccountModel, DoiTuong } from '@/types/schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { FormMode } from '@/types/form';
import { DetailTab } from './DetailTab';
import { OtherTab } from './OtherTab';

interface SearchDialogProps {
  formMode: FormMode;
  open: boolean;
  initialData?: SearchFormValues;
  onSubmit?: (data: SearchFormValues) => void;
  onClose: () => void;
}

const SearchDialog = ({ open, onClose, onSubmit, formMode, initialData }: SearchDialogProps) => {
  const [taiKhoan, setTaiKhoan] = useState<AccountModel | null>(null);
  const [khachHang, setKhachHang] = useState<DoiTuong | null>(null);

  const handleSubmit = (data: SearchFormValues) => {
    const searchData = {
      ...data,
      ma_tk: taiKhoan?.uuid || '',
      ma_kh: khachHang?.uuid || ''
    };
    onSubmit?.(searchData);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={'Bảng xác nhận công nợ'}
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode={formMode}
        hasAritoActionBar={false}
        schema={SearchFormSchema}
        onSubmit={handleSubmit}
        initialData={initialData}
        className='w-[900px]'
        headerFields={<BasicInfoTab taiKhoan={taiKhoan} setTaiKhoan={setTaiKhoan} />}
        tabs={[
          {
            id: 'detail',
            label: 'Chi tiết',
            component: <DetailTab khachHang={khachHang} setKhachHang={setKhachHang} />
          },
          {
            id: 'other',
            label: 'Khác',
            component: <OtherTab />
          }
        ]}
        bottomBar={<BottomActionBarV2 mode={formMode} onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
